import React from "react";
import { ThreeDots } from "react-loading-icons";

const LoaderMessage = ({ type }) => {
  const color = type === "user" ? "#000" : "#fff";
  return (
    <div className={`message ${type}`}>
      <ThreeDots
        speed={0.75}
        stroke={color}
        fill={color}
        strokeWidth={1}
        width={50}
      />
    </div>
  );
};

export default LoaderMessage;